import { useContext, useCallback } from "react";
import { useMixPanelForTracking } from "../../../utils/TrackMixPanel";
import { MyCompanyProfileContext } from "../../../MyCompanyProfileContext";
import { UserApiContext } from "../../UserDetailsContext/UserDetailsContext";

/**
 * Custom hook for tracking events in the Indent module.
 * Automatically attaches user and company context and
 * standardizes the module name as "Indent".
 */
export const useIndentTracking = () => {
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);

  const { TrackMixPanel } = useMixPanelForTracking(
    userDetails,
    companySettingData
  );

  /**
   * Wrapper function to simplify Indent-related tracking calls.
   * @param {string} screen - The screen or page name
   * @param {string} definition - Description of the user action
   * @param {object|string} [data] - Optional payload data
   */
  const trackIndentEvent = useCallback(
    (screen, definition, data = "None") => {
      TrackMixPanel({
        ModuleName: "lorri indent",
        ScreenName: screen,
        Data: data,
        Definition: definition,
      });
    },
    [TrackMixPanel]
  );

  return { trackIndentEvent };
};
